<template>
  <v-row>
    <v-col class="py-4">
      <v-row v-if="screen.logo_base64">
        <v-col
          class="py-0  d-flex justify-center"
          offset-sm="4"
          sm="4"
        >
          <v-img
            contain
            height="80pt"
            width="100pt"
            :src="'data:image/jpg;base64,'+screen.logo_base64"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center pb-1">
          <span :style="`color: ${screen.text1.color};font-size: ${screen.text1.size}px`">
            {{ screen.text1.text }}
          </span>
        </v-col>
        <!--        <v-col class="text-center pb-1">-->
        <!--          {{ screen.text1.text }}-->
        <!--        </v-col>-->
      </v-row>
      <v-row>
        <v-col class="text-center py-1">
          <span :style="`color: ${screen.text2.color}; font-size: ${screen.text2.size}px`">
            {{ this.screen.text2.text }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="(planogramm, index) in planogramms "
          v-show="(planogramm.amount>0 && configurationType==ConfigurationTypeEnum.Vitrina) || (planogramm.price_cashless>0 && configurationType==ConfigurationTypeEnum.Donation) || (planogramm.amount>0 && configurationType==ConfigurationTypeEnum.Rele)"
          :key="index"
          cols="6"
          sm="4"
        >
          <v-btn
            width="100%"
            :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
            @click="onChooseItem(planogramm)"
          >
            {{ showOnTheButton(planogramm) }}
          </v-btn>
        </v-col>
        <v-col
          v-for="(planogramm, index) in planogramms "
          v-show="((planogramm.amount==0 || !planogramm.amount) && (configurationType==ConfigurationTypeEnum.Vitrina || configurationType==ConfigurationTypeEnum.Rele)) || (planogramm.price_cashless==0 && (configurationType==ConfigurationTypeEnum.Donation ))"
          :key="index + 'z'"
          cols="12"
        >
          <v-btn
            width="100%"
            :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
            @click="onChooseScreen(planogramm)"
          >
            {{ planogramm.description }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script >
import {
  configuration,
  ConfigurationDescriptionTypeEnum,
  ConfigurationTypeEnum
} from "@/views/loyalty/models/justpay-configuration.model"
import { setScreenBackground } from "@/views/loyalty/shared/modules/utilities"

export default {
  name: 'ConfigurationFirstscreen',
  computed: {
    ConfigurationTypeEnum () {
      return ConfigurationTypeEnum
    }
  },
  props: {
    configurationType: {
      type: Number,
      default: 0
    },
    screen: {
      type: Object,
      default: configuration.interface_description.first_screen
    },
    planogramms: {
      type: Array,
      default: configuration.planogramm
    }
  },
  data: () => ({
    // myStyle: { backgroundColor: '' },
    planogramm: null,
}),
  watch: {
    'screen.background' (newValue) {
      setScreenBackground(newValue)
    }
  },
  beforeMount () {
    console.log('text->', this.screen.text1.text)
  },
  methods: {
    async onChooseItem (planogramm) {
      this.planogramm = planogramm
      console.log('planogram', planogramm)
      if (this.configurationType == ConfigurationTypeEnum.Donation) {
        if (planogramm.price_cashless == 0) {
          // this.firstScreen = false
          // this.secondScreen = true
          // this.errorScreen = false
          this.priceOfGoods = planogramm.price_cashless
        } else {
          this.amountForPay = planogramm.price_cashless
          console.log('this.amountForPay', this.amountForPay)
          const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
          console.log('nomenclature', nomenclature)
          const items = [{
            name: nomenclature.name,
            count: 1,
            amount: this.amountForPay,
            price: this.amountForPay
          }]
          this.startToPay(items)
        }
      }
      if (this.configurationType == ConfigurationTypeEnum.Vitrina) {
        if (planogramm.amount == 0 || !planogramm.amount) {
          // this.firstScreen = false
          // this.secondScreen = true
          // this.errorScreen = false
          this.priceOfGoods = planogramm.price_cashless
        } else {
          this.amountForPay = planogramm.amount * planogramm.price_cashless
          console.log('this.amountForPay', this.amountForPay)
          const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
          console.log('nomenclature', nomenclature)
          const items = [{
            name: nomenclature.name,
            count: this.planogramm.amount,
            amount: this.amountForPay,
            price: planogramm.price_cashless
          }]
          this.startToPay(items)
        }
      }
      // 9 is the relay
      if (this.configurationType == ConfigurationTypeEnum.Rele) {
        this.amountForPay = planogramm.amount * planogramm.price_cashless
        console.log('this.amountForPay', this.amountForPay)
        // const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        // console.log('nomenclature', nomenclature)
        const items = [{
          amount: this.amountForPay,
          count: 1,
          equipmentId: planogramm.equipment,
          name: planogramm.description, //  nomenclature.name,
          price: this.amountForPay,
          scenarioId: planogramm.scenario
        }]
        console.log('items', items)
        this.startToPay(items)
      }
    },
    onChooseScreen(planogramm) {
      this.amountForPay = planogramm.price_cashless
      console.log('this.amountForPay', this.amountForPay)
      const item = {
        amount: this.amountForPay,
        count: 1,
        equipmentId: planogramm.equipment,
        name: planogramm.description, //  nomenclature.name,
        price: this.amountForPay,
        scenarioId: planogramm.scenario
      }
      console.log('item', item)
      this.$emit('screen', item)
    },
    showOnTheButton (planogramm) {
      let itemToShow = 0
      if (this.configurationType == ConfigurationTypeEnum.Donation) {
        itemToShow = planogramm.price_cashless
      }
      if (this.configurationType == ConfigurationTypeEnum.Vitrina) {
        itemToShow = planogramm.amount
      }
      if (this.configurationType == ConfigurationTypeEnum.Rele) {
        if (planogramm.descriptionType == ConfigurationDescriptionTypeEnum.Sum) {
          itemToShow = `${planogramm.amount * planogramm.price_cashless} ${this.unitOfMeasure(planogramm.descriptionType)}`
        }
        if (planogramm.descriptionType == ConfigurationDescriptionTypeEnum.Quantity) {
          itemToShow = `${planogramm.amount} ${this.unitOfMeasure(planogramm.descriptionType)}`
        }
        if (planogramm.descriptionType == ConfigurationDescriptionTypeEnum.Overview
        ) {
          itemToShow = planogramm.description
        }
      }
      return itemToShow
    },
    startToPay (items) {
      this.$emit('data', items)
    },
    unitOfMeasure (type) {
      if (type === ConfigurationDescriptionTypeEnum.Sum) return 'руб.'
      if (type === ConfigurationDescriptionTypeEnum.Quantity) return 'шт.'
    }
  }
}
</script>

<style scoped>

</style>
